import React,{ useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import axios from 'axios';
import useSWR from 'swr'
import Spinner from "./components/Spinner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Swiper, { Navigation } from "swiper";
import './../sass/style.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ContactForm from "./components/ContactForm";
import AppContext from './context';
import Modal from "./components/Modal";
import Services from "./components/Services";
import Products from "./components/Products";
import Portfolio from "./components/Portfolio";
import Blog from "./components/Blog";
import About from "./components/About";
import References from "./components/References";
import Feedback from "./components/Feedback";
import Image from "./components/Image";
import { motion } from "framer-motion";
import LandingForm from "./components/LandingForm";
import useScreenSize from "./extras/screenSize";

const url = window.location.pathname;
const fetcher = url => axios.get(url).then(res => res.data)

const RenderSection = ({id,modal_image}) => {
    const landingProp = {
        page: 'landing',
        modalImage : modal_image
    }
    switch (id) {
        case "3":
            return <About {...landingProp} />
        case "4":
            return <Services {...landingProp} />
        case "5":
            return <Products {...landingProp} />
        case "6":
            return <Portfolio {...landingProp} />
        case "7":
            return <Blog {...landingProp} />
        case "23":
            return <Feedback {...landingProp} />
        case "31":
            return <References appendClass="mt-4" {...landingProp} />

        default:
            return <></>
    }
}

function Landing() {
    const { data, error } = useSWR('https://www.bwa.com.tr/api'+url, fetcher)
    const [contextData, setContextData] = useState(null);
    const { width:screenWidth } = useScreenSize();

    const Btn = ({style, className}) => {
        return <a
        id="landing-btn"
        target="_blank"
        onClick={() => setContextData({
            status: 'visible',
            content: <LandingForm image={data?.page?.category_language.extra?.modal_image} />
        })}
        className={`mx-auto btn btn-bwa ${ className }`}
        style={{ maxWidth:'300px', cursor:'pointer', ...style }}>
            {translations.landing_btn}
        </a>;
    }

    useEffect(() => {
        if (data) {
            Swiper.use([Navigation]);
            new Swiper('.intro-slider', {
                loop:false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });

            document.querySelectorAll('.btn-render').forEach((e) => {
                ReactDOM.render(<Btn className="d-inline-block" style={{ padding:'16px 20px' }} />,e);
            })
        }
    }, [data])

    return data ? (
    <AppContext.Provider value={{ contextData, setContextData }}>
    <Header data={data.header} inPage={true} />
    {data?.slider && (
        <div className="swiper intro-slider">
            <div className="swiper-wrapper">
                {data?.slider.map((item,i) => {
                    return <div className="swiper-slide" key={i}>
                        <div className="slide-container">
                        <Image image={item.file} />
                        </div>
                    </div>
                })}
            </div>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
        </div>
    )}

    <div className="articles landing-articles">
        <div className="px-0 mx-0 row w-100">
            <div className="col-xl-12">
                {data?.page?.category_language.contents && (
                    <section className="container about">
                        <div className="px-3 row h-100 px-xl-0">
                            <div className="col-12 px-xl-4">
                                {screenWidth > 1024 && (
                                    <div className="col-xl-6 about-in-page">
                                    <motion.div
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once:true }}
                                        variants={{
                                            hidden: { top: 50, right:25},
                                            visible: { top: 0, right:0 }
                                        }}
                                        transition={{ duration: 1.2 }}
                                    className="square"></motion.div>
                                    <motion.div
                                    className="image"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once:true }}
                                    variants={{
                                        hidden: { marginRight: -50, marginTop:-50},
                                        visible: { marginRight: 0, marginTop:0 }
                                    }}
                                    transition={{ duration: 1.2 }}>
                                        <Image image={data?.page?.file} alt={data?.page?.category_language.alt?.file} />
                                    </motion.div>
                                </div>
                                )}
                                <small>{data?.page?.category_language.name}</small>
                                <h1>{data?.page?.category_language.description}</h1>
                                <h6>{data?.page?.category_language.extra?.h6}</h6>
                                {screenWidth < 1024 && (
                                    <div className="col-xl-6 about-in-page">
                                    <motion.div
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once:true }}
                                        variants={{
                                            hidden: { top: 50, right:25},
                                            visible: { top: 0, right:0 }
                                        }}
                                        transition={{ duration: 1.2 }}
                                    className="square"></motion.div>
                                    <motion.div
                                    className="image"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once:true }}
                                    variants={{
                                        hidden: { marginRight: -50, marginTop:-50},
                                        visible: { marginRight: 0, marginTop:0 }
                                    }}
                                    transition={{ duration: 1.2 }}>
                                        <Image image={data?.page?.file} alt={data?.page?.category_language.alt?.file} />
                                    </motion.div>
                                </div>
                                )}
                                <div id="main_content" dangerouslySetInnerHTML={{ __html: data?.page?.category_language.contents.replaceAll('[[button]]', "<span class='btn-render'></span>") }}></div>

                                <Btn />

                            </div>
                        </div>
                    </section>
                )}

                <section className="article-detail">

                {data?.sections.map((item,index) => <RenderSection id={item} modal_image={data?.page?.category_language.extra?.modal_image} key={index} />)}
                </section>
                <div className="container mt-2">
                    <div className="articles-extra">
                        {(data.page.tags && data.page.tags.length > 0) && (
                        <div className="tags">
                            <span><i className="fas fa-tag"></i> Tag:</span>
                            {data.page.tags?.map((item,index) => {
                                return <a href={"/tags/"+item.slug} key={index}>
                                {item.name}
                            </a>
                            })}
                        </div>
                        )}
                    </div>

                    {data.page.category_language?.extra?.hide_contact_form != 1 && (
                        <section className="contact-form">
                        <h1>{translations.contact_us}</h1>
                        <ContactForm />
                        </section>
                    )}
                </div>
            </div>
        </div>
    </div>
    <Modal />
    <Footer data={data.footer} inPage={true} />
    </AppContext.Provider>
    ) : <Spinner />;
}

ReactDOM.render(
  <Landing />,
  document.getElementById('root')
);
